import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {EmployerIdentificationNumberConfirmationDocumentFormValues} from "./types"
import {einValidation, nameValidation} from "./validationSchemas"

interface EmployerIdentificationNumberConfirmationDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: EmployerIdentificationNumberConfirmationDocumentFormValues
	onSubmit: (values: EmployerIdentificationNumberConfirmationDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	businessName: nameValidation,
	ein: einValidation,
})

export const EmployerIdentificationNumberConfirmationDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: EmployerIdentificationNumberConfirmationDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Business Name</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter business name"
						name="businessName"
						value={values.businessName}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">EIN</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter EIN"
						name="ein"
						value={values.ein}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</form>
			)}
		</Formik>
	)
}
